// import * as React from "react";
import React, { useContext, useEffect, useState } from "react";
import useSnackbar from "./../../../../hooks/useSnackbar";
import _ from "lodash";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

import { addressParse } from "@zerodep/address-parse";

import {
  Autocomplete,
  TextField,
  Snackbar,
  Alert,
  Button,
  Grid,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  Typography,
  OutlinedInput,
  FormHelperText
} from "@mui/material";

import UndoIcon from "@mui/icons-material/Undo";

import { useTheme } from "@mui/material/styles";
import AlertDialog from "../../../../components/Dialogs/AlertDialog";

import { useFormik } from "formik";
import * as Yup from "yup";

import {
  EMAIL_REGEX,
  PASSWORD_REGEX,
  SCOPE_MODES
} from "../../../../constants";

import HttpContext from "../../../../contexts/HTTP/HttpContext";

function CreateCharityDialog({ open, handleClose, handleSaveEditChanges }) {
  const theme = useTheme();

  const [charityScope, setCharityScope] = useState(null);
  const [enabled, setEnabled] = useState(null);

  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const { openSnackbar } = useSnackbar();

  const saveChanges = async () => {
    // const payload = {
    //   id: charity?._id,
    //   charityID: charityID,
    //   name: charityName,
    //   logoUrl: charityLogoURL,
    //   mission: charityMission,
    //   location: { description: charityAddress },
    //   scope: charityScope,
    //   enabled: enabled
    // };

    let payload = {};

    if (charityScope !== null) {
      payload.scope = charityScope;
    }
    if (enabled !== null) {
      payload.enabled = enabled;
    }

    await handleSaveEditChanges(payload);
  };

  const revertChanges = async () => {
    setCharityScope(null);
    setEnabled(null);

    //handleClose();
  };

  const performClose = async () => {
    setCharityScope(null);
    setEnabled(null);

    handleClose();
  };

  return (
    <React.Fragment>
      <Dialog
        fullWidth={false}
        maxWidth={false}
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-kiosklist"
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            width: "30vw"
          }}
        >
          <DialogTitle
            id="modal-kiosklist"
            style={{
              maxWidth: "19vw"
            }}
          >
            {"Update All Charities"}
          </DialogTitle>
          <Button variant="outline" onClick={revertChanges}>
            <UndoIcon style={{ marginRight: theme.spacing(1) }} />
            Revert
          </Button>
        </div>
        <DialogContent>
          <Grid container width="30vw" spacing={2}>
            <Grid item xs={2}></Grid>
            <Grid item xs={10}>
              <div style={{ color: "red", width: "100%" }}>
                WARNING: Saving these changes will affect all charities!
              </div>
            </Grid>
            <Grid item xs={2}>
              {enabled !== null && <div>Changed</div>}
            </Grid>
            <Grid item xs={10}>
              <FormControlLabel
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-start",
                  marginRight: theme.spacing(3)
                }}
                control={
                  <Switch
                    checked={enabled}
                    color="success"
                    onChange={event => {
                      setEnabled(event.target.checked);
                    }}
                  />
                }
                label={enabled ? "Enabled" : "Disabled"}
              />
            </Grid>
            <Grid item xs={2}>
              {charityScope !== null && <div>Changed</div>}
            </Grid>
            <Grid item xs={10}>
              <FormControl fullWidth>
                <InputLabel id="scope-select-label">Scope</InputLabel>
                <Select
                  labelId="scope-open-select-label"
                  id="scope-open-select"
                  label="Scope"
                  value={charityScope}
                  onChange={async event => {
                    setCharityScope(event.target.value);
                  }}
                >
                  <MenuItem value={SCOPE_MODES.CITY}>City</MenuItem>
                  <MenuItem value={SCOPE_MODES.GLOBAL}>Global</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={performClose}>Cancel</Button>
          <Button onClick={saveChanges} color="secondary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

export default CreateCharityDialog;
